import React from "react";
import styles from "./RecipientDataStep.module.scss";
import { observer } from "mobx-react";
import HelpMeItemContainer from "../../ui/HelpMeItemContainer/HelpMeItemContainer";
import TextInput from "../../ui/TextInput/TextInput";
import { useStores } from "../../../../hooks/mobx";
import DateSelector from "../../ui/DateSelector/DateSelector";
import TextAreaInput from "../../ui/TextInput/TextAreaInput";
import DropAndCrop from "../../ui/DropAndCrop/DropAndCrop";

const RecipientDataStep = observer(() => {
  const { helpMeStore } = useStores();
  const {
    currentModel,
    onChange,
    currentModelErrors,
    currentModelInputData,
    setErrorField,
  } = helpMeStore;

  return (
    <div className={styles.RecipientDataStep}>
      <div className={styles.RecipientDataStep_DoubleContainer}>
        <HelpMeItemContainer
          title={"Фамилия"}
          required={currentModelInputData["last_name"].required}
          id={"last_name"}
        >
          <TextInput
            value={currentModel["last_name"]}
            placeholder={currentModelInputData["last_name"].placeholder}
            error={currentModelErrors["last_name"]}
            onChange={(value) => onChange("last_name", value)}
          />
        </HelpMeItemContainer>
        <HelpMeItemContainer
          title={"Имя"}
          required={currentModelInputData["first_name"].required}
          id={"first_name"}
        >
          <TextInput
            value={currentModel["first_name"]}
            placeholder={currentModelInputData["first_name"].placeholder}
            error={currentModelErrors["first_name"]}
            onChange={(value) => onChange("first_name", value)}
          />
        </HelpMeItemContainer>
      </div>
      <div className={styles.RecipientDataStep_DoubleContainer}>
        <HelpMeItemContainer
          title={"Отчество"}
          required={currentModelInputData["middle_name"].required}
          id={"middle_name"}
        >
          <TextInput
            value={currentModel["middle_name"]}
            placeholder={currentModelInputData["middle_name"].placeholder}
            error={currentModelErrors["middle_name"]}
            onChange={(value) => onChange("middle_name", value)}
          />
        </HelpMeItemContainer>
        <HelpMeItemContainer
          title={"Дата рождения"}
          required={currentModelInputData["birth_date"].required}
          id={"birth_date"}
        >
          <div
            className={
              styles.RecipientDataStep_DoubleContainer_DatePickerContainer
            }
          >
            <DateSelector
              value={currentModel["birth_date"]}
              placeholder={currentModelInputData["birth_date"].placeholder}
              error={currentModelErrors["birth_date"]}
              onChange={(value) => onChange("birth_date", value)}
            />
          </div>
        </HelpMeItemContainer>
      </div>
      <HelpMeItemContainer
        title={"Причина поиска"}
        required={currentModelInputData["search_reason"].required}
        id={"search_reason"}
      >
        <TextAreaInput
          maxLength={2000}
          value={currentModel["search_reason"]}
          placeholder={currentModelInputData["search_reason"].placeholder}
          error={currentModelErrors["search_reason"]}
          onChange={(value) => onChange("search_reason", value)}
        />
      </HelpMeItemContainer>
      <HelpMeItemContainer
        title={"Фото реципиента"}
        required={currentModelInputData["_image"].required}
        id={"_image"}
        extraPaddings
      >
        <DropAndCrop
          image={currentModel["_image"]}
          onImageAccept={(image) => onChange("_image", image)}
          error={currentModelErrors["_image"]}
          setError={(value) => setErrorField("_image", value)}
          imageSize={200}
        />
      </HelpMeItemContainer>
    </div>
  );
});

export default RecipientDataStep;
